<div class="jumbotron">
  <div class="container">
    <h1 class="display-4">Staff Home</h1>
    <p class="lead">해당페이지는 지정된 위치에서만 접속이 가능합니다.</p>
  </div>
</div>
<div class="container">
  <div id="issue" class="mb-3">
    <h5>에러게시판</h5>
    <app-issue-tracking></app-issue-tracking>
  </div>

</div>
